import {
  NOTA_AVULSA_BASE_URL,
  MTP_BASE_URL,
  ELEMENTAR_BASE_URL,
  HUMAN_LOOP_BASE_URL,
  FORWARD_BASE_URL,
  FORWARD_KEY,
  ELEMENTAR_ANALYSIS_BASE_URL,
  SAFE_NFSE_BASE_URL
} from '../../apiRoutes';
import {
  http,
  handleErrors,
  handleMessages
} from '../../services/http-wrapper';
import { Auth } from 'aws-amplify';
import { asUuid } from '../../services/secrets';
import { toast } from 'react-toastify';
import axios from 'axios';

// HUMAN LOOP
export const ApiNcmSelector = async ({ ncm, ufs }) => {
  let message = 'NCM enviado com sucesso';
  let data = {
    ncm: ncm,
    ufs: ufs
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.altPost(
      `${HUMAN_LOOP_BASE_URL}/human_loop/check_point`,
      data,
      user.getIdToken().getJwtToken(),
      message
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostLoopNcm = async ({ ncm, description }) => {
  let data = {
    ncm: ncm,
    description: description
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${HUMAN_LOOP_BASE_URL}/human_loop/ncm_model`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiHumanLoopValidateNcm = async ({ ncm, descricao }) => {
  let data = {
    ncm: ncm,
    descricao: descricao
  };
  try {
    let user = await Auth.currentSession();
    const response = await http.post(
      `${HUMAN_LOOP_BASE_URL}/human_loop/validate_ncm`,
      data,
      user.getIdToken().getJwtToken()
    );
    return response.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiHumanLoopModifyTrainingData = async ({
  status,
  ncm,
  descricao,
  modify
}) => {
  let data = {
    status: status,
    ncm: ncm,
    descricao: descricao,
    modify: modify
  };
  try {
    let user = await Auth.currentSession();
    const response = await http.post(
      `${HUMAN_LOOP_BASE_URL}/human_loop/modify_traning`,
      data,
      user.getIdToken().getJwtToken()
    );
    return response.data;
  } catch (error) {
    handleErrors(error);
  }
};
// MAKE FORWARD TAGS
export const ApiPostTag = async ({ tag_name, cnpj, cor, tipo_documento }) => {
  let data = {
    tag_name: tag_name,
    cnpj: cnpj,
    cor: cor,
    tipo_documento: tipo_documento
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/create/tag`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// cnpj vai virar id_empresa
export const ApiGetTags = async ({ id_empresa, tipo_documento }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/tag?id_empresa=${id_empresa}&tipo_documento=${tipo_documento}&page=1`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

export const ApiDeleteTag = async (Id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/delete/tag/${Id}`,
      user.getIdToken().getJwtToken(),
      { Id }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// MAKE FORWARD TAGS TAG AVISO
export const ApiGetTagAviso = async (id_tag) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/tag_aviso?id_tag=${id_tag}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostTagAviso = async ({
  id_tag,
  email,
  whatsapp,
  desc_aviso
}) => {
  let data = {
    id_tag: id_tag,
    email: email,
    whatsapp: whatsapp,
    desc_aviso: desc_aviso
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/create/tag_aviso`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateTagAviso = async ({
  id_tag,
  email,
  whatsapp,
  desc_aviso
}) => {
  let data = {
    id_tag: id_tag,
    email: email,
    whatsapp: whatsapp,
    desc_aviso: desc_aviso
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/update/tag_aviso`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    // handlerErros(error);
    throw error;
  }
};

export const ApiDeleteTagAviso = async (id_aviso) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/delete/tag_aviso/${id_aviso}`,
      user.getIdToken().getJwtToken(),
      { id_aviso }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// MAKE FORWARD TAGS TAG WORKFLOW
export const ApiGetTagWorkflow = async ({ cnpj, page, tipo_documento }) => {
  let validPage;
  if (page === 0 || page === '0') {
    validPage = 1;
  } else {
    validPage = page;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/tag_workflow?cnpj=${cnpj}&tipo_documento=${tipo_documento}&page=${validPage}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

export const ApiPostTagWorkflow = async ({
  tipo_nota,
  id_tag_orig,
  id_tag_dest,
  cnpj,
  tipo_validacao,
  tipo_documento
}) => {
  let data = {
    tipo_nota: tipo_nota,
    id_tag_orig: id_tag_orig,
    id_tag_dest: id_tag_dest,
    cnpj: cnpj,
    tipo_validacao: tipo_validacao,
    tipo_documento: tipo_documento
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.voidPost(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/create/tag_workflow`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteTagWorkflow = async (tag_workflow) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/delete/tag_workflow/${tag_workflow}`,
      user.getIdToken().getJwtToken(),
      { tag_workflow }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// MAKE FORWARD TAGS TAG NOTA
export const ApiPostTagNota = async ({ id_notas, id_tag, tipo_documento }) => {
  let data = {
    id_notas: id_notas,
    id_tag: id_tag,
    tipo_documento: tipo_documento
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/create/tag_nota`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetTagValidation = async ({
  id_notas,
  id_tag,
  status,
  tipo_documento
}) => {
  let data = {
    id_notas: id_notas,
    id_tag: id_tag,
    status: status,
    tipo_documento: tipo_documento
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/validar_tag`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
  }
};

// MAKE FORWARD INTEGRATIONS
export const ApiGetExecucoes = async () => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/execucao`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostTagExecucao = async ({
  id_tag,
  execucao,
  lambda,
  descricao_lambda,
  id_execucao
}) => {
  let data = {};
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/create/tag_execucao?id_tag=${id_tag}&execucao=${execucao}&Lambda=${lambda}&descricao_Lambda=${descricao_lambda}&id_execucao=${id_execucao}`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetTagExecucoes = async (id_tag) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/tag_execucao?id_tag=${id_tag}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateTagExecucao = async ({
  integration,
  descricao_Lambda,
  execucao,
  id_tag,
  Lambda
}) => {
  let data = {
    descricao_Lambda: descricao_Lambda,
    execucao: execucao,
    id_tag: id_tag,
    Lambda: Lambda
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/update/tag_execucao/${integration}`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    // handlerErros(error);
    throw error;
  }
};

export const ApiDeleteTagExecucao = async (tag_execucao) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/delete/tag_execucao/${tag_execucao}`,
      user.getIdToken().getJwtToken(),
      { tag_execucao }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// MAKE FORWARD HOME PAGE ACTIONS
export const ApiGetZipFiles = async ({
  cnpj,
  data_inicio,
  data_fim,
  tipo_nota
}) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${MTP_BASE_URL}/stored_files/keys/${cnpj}?data_inicio=${data_inicio}&data_fim=${data_fim}&tipo_nota=${tipo_nota}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetCompanyList = async () => {
  try {
    const api = await http.secretsManagerGet(`/forward/empresa`);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetInvoiceSystemMessage = async (empresa_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/system_message?empresa_id=${empresa_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostCertificateUpdate = async ({
  uuid,
  certificado,
  cpfCnpj,
  razaoSocial,
  senhaCertificado,
  uf
}) => {
  console.log('uuid:', uuid);
  let path = uuid
    ? `${FORWARD_BASE_URL}/forward/empresa/${uuid}`
    : `${FORWARD_BASE_URL}/forward/empresa`;
  console.log('path:', path);
  let data = {
    ambiente: 'PRODUCAO',
    cpfCnpj: cpfCnpj,
    razaoSocial: razaoSocial,
    uf: uf,
    buscaNfsEntrada: true,
    buscaNfsSaida: true,
    ambienteCte: 'PRODUCAO'
  };
  if (certificado) {
    data.certificado = certificado;
  }

  if (senhaCertificado) {
    data.senhaCertificado = senhaCertificado;
  }
  try {
    const api = await http.secretsManagerPost(path, data);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

/*
export const ApiPostNotaFiles = async ({
  arquivoXml,
  idEmpresa,
  tipoNota,
  cnpjEmpresa,
  nome
}) => {
  !nome && console.log(nome);
  let url = `${NOTA_AVULSA_BASE_URL}/api/v1/notas-entrada/uploadNota`;
  let data = {
    arquivoXml: arquivoXml,
    idEmpresa: idEmpresa,
    tipoNota: tipoNota,
    cnpjEmpresa: cnpjEmpresa
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(url, data, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};
*/

export const ApiPostNotaFiles = async ({
  arquivoXml,
  idEmpresa,
  tipoNota,
  cnpjEmpresa,
  nome
}) => {
  !nome && console.log(nome);
  let url = `${NOTA_AVULSA_BASE_URL}/api/v1/notas-entrada/uploadNota`;
  let data = {
    arquivoXml: arquivoXml,
    idEmpresa: idEmpresa,
    tipoNota: tipoNota,
    cnpjEmpresa: cnpjEmpresa
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.toastPost(
      url,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

/*
export const ApiPostXlsInvoice = async (xlsInvoice) => {
  let url = `${FORWARD_BASE_URL}/forward/notas-entrada/excel`;
  let data = xlsInvoice;
  try {
    const api = await http.secretsManagerPost(url, data);
    return api;
  } catch (error) {
    handleErrors(error);
  }
};
*/

export const ApiPostXlsInvoice = async ({ url, data }) => {
  try {
    const api = await http.simplePost(url, data);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetXlsReports = async ({ idUsuario, page, size, Silent }) => {
  const url = `${NOTA_AVULSA_BASE_URL}/api/v1/historico-relatorio?idUsuario=${idUsuario}&page=${page}&size=${size}&sort=dataInicioProcessamento,DESC`;
  try {
    const api = Silent
      ? await http.simpleGetSilent(url)
      : await http.simpleGet(url);
    return api.data;
  } catch (error) {
    // simpleGet já mostraria toast internamente mesmo com Silent (não é o
    // simpleGetSilent) — só chama handleErrors aqui quando não for silencioso.
    if (Silent) {
      throw error;
    }
    handleErrors(error);
  }
};

export const ApiUpdateInvoiceQtd = async (body) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/update/dados_itens`,
      body,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
    throw error;
  }
};

export const ApiValidateInvoiceItems = async (body) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/update/validation_by_itens`,
      body,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiGetInvCodMunicipio = async (uuid) => {
  try {
    const api = await http.secretsManagerGet(`/forward/empresa/${uuid}`);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostSendNFe = async (invoiceSpecs) => {
  let data = {
    invoice_key: invoiceSpecs.invoice_key,
    invoice_type: invoiceSpecs.invoice_type,
    company_cnpj: invoiceSpecs.company_cnpj,
    send_according: invoiceSpecs.send_according
  };
  if (invoiceSpecs.send_according === 'NFE' && invoiceSpecs.order_difference) {
    data.order_difference = invoiceSpecs.order_difference;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/add-invoice-transfer`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// MAKE FORWARDS HOME PAGE TABLE
export const ApiGetNotasByCnpj = async ({ cnpj, page, size }) => {
  try {
    const api = await http.simpleGet(
      `${NOTA_AVULSA_BASE_URL}/api/v1/notas-entrada?cnpjEmpresa=${cnpj}&page=${page}&size=${size}`
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//API principal do Make Forward Home (list nota) - criada pelo Samuel
/*export const ApiGetNotasFiltered = async (notaAvulsaFilters) => {
  let chave = notaAvulsaFilters.chave;
  if (
    chave != '' &&
    chave != undefined &&
    chave != null &&
    chave != [] &&
    chave != {}
  ) {
    try {
      const api = await http.secretsManagerGet(
        `/forward/notas-entrada/chave/${notaAvulsaFilters.chave}`
      );
      let singleInvoice = api.data;
      let singleInvoiceId = singleInvoice?.dadosNota?.id;
      let singleInvoiceUuid = singleInvoiceId ? asUuid(singleInvoiceId) : null;
      let uuid = singleInvoiceUuid?.uuid || '';
      singleInvoice.uuid = uuid;
      if (singleInvoice.dadosNota) {
        singleInvoice.dadosNota.uuid = uuid;
      }
      let contentData = {
        content: [singleInvoice],
        number: 0,
        numberOfElements: 1,
        size: 1,
        totalElements: 1,
        totalPages: 1
      };
      return contentData;
    } catch (error) {
      handleErrors(error);
    }
  }
  let filters = Object.keys(notaAvulsaFilters)
    .filter((pos) => notaAvulsaFilters[pos] != '')
    .reduce((a, pos) => ({ ...a, [pos]: notaAvulsaFilters[pos] }), {});
  /*creates an array with all notaAvulsaFilters keys names*/
/*run through this array to use its items to filter the original object to get only the keys that are not empty*/
/*and finally, creates a new object with new keys and values for those keys that are taken from the original object as well*/
/*if (notaAvulsaFilters.page === 0) {
    filters = {
      ...filters,
      page: 0
    };
  }
  if (notaAvulsaFilters.size === 0 || !notaAvulsaFilters.size) {
    filters = {
      ...filters,
      size: 20
    };
  }
  let filtersArray = Object.entries(filters);
  let queryArray = [];
  for (let i = 0; filtersArray.length > i; i++) {
    let field = filtersArray[i][0];
    let value = filtersArray[i][1];
    let queryString = `&${field}=${value}`;
    queryArray.push(queryString);
  }
  let query = queryArray.join('');
  try {
    const api = await http.secretsManagerGet(`/forward/notas-entrada?${query}`);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};
*/

//API principal do Make Forward Home (list nota) - criada pelo Zaidon (exceção com filtro de chave)
export const ApiGetNotasFiltered = async (notaAvulsaFilters) => {
  let chave = notaAvulsaFilters.chave;
  if (
    chave != '' &&
    chave != undefined &&
    chave != null &&
    chave != [] &&
    chave != {}
  ) {
    try {
      const api = await axios.get(
        `${FORWARD_BASE_URL}/forward/notas-entrada/chave/${chave}`,
        { headers: { 'x-api-key': FORWARD_KEY } }
      );
      let singleInvoice = api.data;
      let singleInvoiceId = singleInvoice?.dadosNota?.id;
      let singleInvoiceUuid = singleInvoiceId ? asUuid(singleInvoiceId) : null;
      let uuid = singleInvoiceUuid?.uuid || '';
      singleInvoice.uuid = uuid;
      if (singleInvoice.dadosNota) {
        singleInvoice.dadosNota.uuid = uuid;
      }
      let contentData = {
        content: [singleInvoice],
        number: 0,
        numberOfElements: 1,
        size: 1,
        totalElements: 1,
        totalPages: 1
      };
      return contentData;
    } catch (error) {
      if (error.response?.status === 400) {
        toast.warning('Não há notas para essa chave');
        return {
          content: [],
          number: 0,
          numberOfElements: 0,
          size: 0,
          totalElements: 0,
          totalPages: 0
        };
      }
      handleErrors(error);
    }
  }
  let filters = Object.keys(notaAvulsaFilters)
    .filter((pos) => notaAvulsaFilters[pos] != '')
    .reduce((a, pos) => ({ ...a, [pos]: notaAvulsaFilters[pos] }), {});
  /*creates an array with all notaAvulsaFilters keys names*/
  /*run through this array to use its items to filter the original object to get only the keys that are not empty*/
  /*and finally, creates a new object with new keys and values for those keys that are taken from the original object as well*/
  if (notaAvulsaFilters.page === 0) {
    filters = {
      ...filters,
      page: 0
    };
  }
  if (notaAvulsaFilters.size === 0 || !notaAvulsaFilters.size) {
    filters = {
      ...filters,
      size: 20
    };
  }
  let filtersArray = Object.entries(filters);
  let queryArray = [];
  for (let i = 0; filtersArray.length > i; i++) {
    let field = filtersArray[i][0];
    let value = filtersArray[i][1];
    let queryString = `&${field}=${value}`;
    queryArray.push(queryString);
  }
  let query = queryArray.join('');
  let user = await Auth.currentSession();
  try {
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/notas-entrada?${query}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// ALTERAR
export const ApiGetSingleNota = async (exampleUuid) => {
  try {
    const api = await http.simpleSecManGet(
      `/forward/notas-entrada/${exampleUuid}`
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostDownloadMultipleInvoices = async ({
  dataInicio,
  dataFim,
  cnpjEmpresa,
  tipo,
  idUsuario,
  tipoNota
}) => {
  const fields = {
    dataInicio: dataInicio,
    dataFim: dataFim,
    cnpjEmpresa: cnpjEmpresa,
    tipo: tipo,
    idUsuario: idUsuario,
    tipoNota: tipoNota
  };
  const queryArray = Object.entries(fields)
    .filter(
      ([key, value]) =>
        key && value !== undefined && value !== null && value !== ''
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    );
  const queryString = queryArray.length ? `?${queryArray.join('&')}` : '';
  const url = `${NOTA_AVULSA_BASE_URL}/api/v1/notas-entrada/downloadDocumentos${queryString}`;
  try {
    const response = await http.simpleGet(url);
    return response.data;
  } catch (error) {
    handleErrors(error);
  }
};

// MAKE FORWARD INVOICE ANALYSIS
export const ApiGetSingleNfe = async (uuid) => {
  try {
    const api = await http.secretsManagerGet(`/forward/notas-entrada/${uuid}`);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetNCMDesc = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list?id_nota_entrada=${id}&table=erroncmnota`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetNCMCNAE = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list?id_nota_entrada=${id}&table=erroncmcnae`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetICMSIncid = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list?id_nota_entrada=${id}&table=errocfopicms`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetICMSAliq = async ({ id, empresa_id }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list?id_empresa=${empresa_id}&id_nota_entrada=${id}&table=erroaliquotaicms`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// MAKE FORWARD INVOICE DETAILS
export const ApiGetInvoiceEvents = async ({ id, page, perPage }) => {
  let validPage;
  if (page === 0 || page === '0') {
    validPage = 1;
  } else {
    validPage = page;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/dados_suframa?chave_nota=${id}&page=${validPage}&per_page=${perPage}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDocData = async ({ id, type }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list_nota/${id}?invoice_type=${type}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
  }
};

export const ApiGetDocItens = async (uuid) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/dados_itens/${uuid}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDANFE = async (id) => {
  try {
    const api = await http.simpleGet(
      `${NOTA_AVULSA_BASE_URL}/api/v1/notas-entrada/impressao/${id}`
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDANFESide = async (uuid) => {
  try {
    const api = await http.secretsManagerGet(
      `/forward/notas-entrada/impressao/${uuid}`
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDANFECte = async (uuid) => {
  try {
    const api = await http.secretsManagerGet(`/forward/cte/impressao/${uuid}`);
    return api.data;
  } catch (error) {
    // Antes só logava e não relançava — o thunk via a chamada como
    // "sucesso" com payload undefined em vez de rejeitada, deixando
    // notaDANFECte = undefined (em vez de manter o [] inicial seguro) e
    // derrubando a tela de Detalhes do CTe (ver isBase64 em
    // InvoiceCteDetailsTabs). Relançar garante que getDANFECte.rejected
    // rode e o estado seguro seja preservado.
    handleErrors(error);
  }
};

export const ApiGetInvoiceOrderItems = async ({ uuid, page, per_page }) => {
  let validPage;
  if (page === 0 || page === '0') {
    validPage = 1;
  } else {
    validPage = page;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/pedido/list/fornecedor/${uuid}?page=${validPage}&per_page=${per_page}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetOrderById = async ({ id, page, per_page }) => {
  let validPage;
  if (page === 0 || page === '0') {
    validPage = 1;
  } else {
    validPage = page;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/pedido/list/pedido/${id}?page${validPage}&per_page=${per_page}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostOrderConfirmation = async ({
  id_dados_itens,
  id_item_ped,
  quantidade
}) => {
  let data = {
    id_dados_itens: id_dados_itens,
    id_item_ped: id_item_ped,
    quantidade: quantidade
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/pedido/validacao`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostInvOrder = async ({
  cnpj_emit,
  cnpj_dest,
  data_emissao,
  tipo_fret,
  num_pedido
}) => {
  let data = {
    cnpj_emit: cnpj_emit,
    cnpj_dest: cnpj_dest,
    data_emissao: data_emissao,
    tipo_fret: tipo_fret,
    num_pedido: num_pedido
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/pedido/create/pedido`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostInvOrderItem = async ({
  id_pedido,
  num_item_pedido,
  cod_prod_interno,
  unid_medida_interna,
  qtd_pedido,
  vl_unitario,
  cod_prod_fornecedor,
  unid_medida_fornecedor,
  taxa_conversao,
  tipo_conversao
}) => {
  let data = {
    id_pedido: id_pedido,
    num_item_pedido: num_item_pedido,
    cod_prod_interno: cod_prod_interno,
    unid_medida_interna: unid_medida_interna,
    qtd_pedido: qtd_pedido,
    vl_unitario: vl_unitario,
    cod_prod_fornecedor: cod_prod_fornecedor,
    unid_medida_fornecedor: unid_medida_fornecedor,
    taxa_conversao: taxa_conversao,
    tipo_conversao: tipo_conversao
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/pedido/create/item_pedido`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostInvOrderByFile = async ({ xml }) => {
  let data = {
    xml: xml
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/pedido/create/by_xml`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateInvOrder = async ({ id, cnpj_emit }) => {
  let data = {
    cnpj_emit: cnpj_emit
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_BASE_URL}/pedido/update/pedido/${id}`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
    throw error;
  }
};

export const ApiUpdateInvOrderItem = async ({
  id,
  num_item_pedido,
  cod_prod_interno,
  unid_medida_interna,
  qtd_pedido,
  vl_unitario,
  cod_prod_fornecedor,
  unid_medida_fornecedor,
  taxa_conversao,
  tipo_conversao
}) => {
  let data = {
    num_item_pedido: num_item_pedido,
    cod_prod_interno: cod_prod_interno,
    unid_medida_interna: unid_medida_interna,
    qtd_pedido: qtd_pedido,
    vl_unitario: vl_unitario,
    cod_prod_fornecedor: cod_prod_fornecedor,
    unid_medida_fornecedor: unid_medida_fornecedor,
    taxa_conversao: taxa_conversao,
    tipo_conversao: tipo_conversao
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_BASE_URL}/pedido/update/item_pedido/${id}`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
    throw error;
  }
};

export const ApiDeleteInvOrder = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_BASE_URL}/pedido/delete/pedido/${id}`,
      user.getIdToken().getJwtToken(),
      { id }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteInvOrderItem = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_BASE_URL}/pedido/delete/item_pedido/${id}`,
      user.getIdToken().getJwtToken(),
      { id }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetInvOrderData = async (id_order_invoice) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/pedido/list/pedido-nota?id_order_invoice=${id_order_invoice}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetCteAssociates = async (chave_nfe) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/start/get_nfe_by_chave?chave_nfe=${chave_nfe}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetNfeAssociatesByCte = async (chave_cte) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/start/get_nfe_by_cte?chave_cte=${chave_cte}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostAddInvTransfer = async ({
  invoice_key,
  invoice_type,
  company_cnpj
}) => {
  let data = {
    invoice_key: invoice_key,
    invoice_type: invoice_type,
    company_cnpj: company_cnpj
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/add-invoice-transfer`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetValidateInvItems = async (invoice_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/validate-invoice-items?invoice_id=${invoice_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    // handleErrors(error);
  }
};

export const ApiGetIdentifyInvOrder = async ({ branch_code, invoice_id }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/identify-invoice-order?invoice_id=${invoice_id}&branch_code=${branch_code}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    // handleErrors(error);
  }
};

export const ApiGetInvListByBranch = async ({
  branch_number,
  cnpj_supplier
}) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/pedido/list-by-branch?branch_number=${branch_number}&cnpj_supplier=${cnpj_supplier}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    // handleErrors(error);
  }
};

// MAKE FORWARD INVOICE ERRORS
export const ApiGetInvoiceErrors = async ({ id, page, per_page }) => {
  let validPage;
  if (page === 0 || page === '0') {
    validPage = 1;
  } else {
    validPage = page;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${MTP_BASE_URL}/erronota/list/${id}?page=${validPage}&per_page=${per_page}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetCrossedNcm = async ({ ncm, ncm_pred }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${MTP_BASE_URL}/erronota/get_item?ncm=${ncm}&ncm_pred=${ncm_pred}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostInvoiceErrorProductMessage = async ({
  cnpj,
  cnpjFornc,
  codProduto,
  codMessage,
  typeMessage
}) => {
  try {
    let data = {
      cnpj: cnpj,
      cnpj_fornc: cnpjFornc,
      cod_produto: codProduto,
      cod_message: codMessage,
      type_message: typeMessage
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/message_produto/create`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// OTHER
export const ApiPostNotaManifestacao = async ({
  uuid,
  tipoManifestacao,
  motivo
}) => {
  let url = `${FORWARD_BASE_URL}/forward/notas-entrada/manifestar/${uuid}`;
  let data = {
    tipoManifestacao: tipoManifestacao,
    motivo: motivo
  };
  try {
    const api = await http.secretsManagerPost(url, data);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//AÇÕES
export const ApiGetReadActions = async (empresa_id) => {
  try {
    const user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/acao?id_empresa=${empresa_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetReadActionsNota = async (uuid) => {
  try {
    const user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/acao_nota/${uuid}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};
/* Transactional 1 de 4 */

export const ApiPostReadActions = async ({ email, nome, empresa }) => {
  let data = {
    email: email,
    nome: nome,
    empresa: empresa
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/create/acao`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostReadActionsNota = async ({
  data_inclusao,
  descricao,
  email,
  id_nota,
  id_acao
}) => {
  let data = {
    data_inclusao: data_inclusao,
    descricao: descricao,
    email: email,
    custom_field: { id_nota },
    id_acao: id_acao
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/create/acao_nota`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

export const ApiUpdateActionsNota = async ({ id, data_fechamento }) => {
  let data = {
    data_fechamento: data_fechamento
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/update/acao_nota/${id}`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
    throw error;
  }
};

//COMENTÁRIOS
export const ApiPostInvoiceComment = async ({
  id_nota_entrada,
  comentario
}) => {
  let data = {
    id_nota_entrada: id_nota_entrada,
    comentario: comentario
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/create/comentarios_nota`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetInvoiceComment = async (id_nota_entrada) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/comentarios_nota?id_nota_entrada=${id_nota_entrada}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// CTE
export const ApiGetZipFilesCte = async ({
  cnpj,
  data_inicio,
  data_fim,
  tipo_nota
}) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/keys/${cnpj}?data_inicio=${data_inicio}&data_fim=${data_fim}&tipo_nota=${tipo_nota}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetNotasCte = async (notasCte) => {
  let filters = Object.keys(notasCte)
    .filter((pos) => notasCte[pos] != '')
    .reduce((a, pos) => ({ ...a, [pos]: notasCte[pos] }), {});
  if (notasCte.page === 0) {
    filters = {
      ...filters,
      page: 0
    };
  }
  if (notasCte.size === 0 || !notasCte.size) {
    filters = {
      ...filters,
      size: 20
    };
  }
  let filtersArray = Object.entries(filters);
  let queryArray = [];
  for (let i = 0; filtersArray.length > i; i++) {
    let field = filtersArray[i][0];
    let value = filtersArray[i][1];
    let queryString = `&${field}=${value}`;
    queryArray.push(queryString);
  }
  let query = queryArray.join('');
  let user = await Auth.currentSession();
  try {
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/ctes-entrada?${query}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetSingleCte = async (uuid) => {
  try {
    const api = await http.secretsManagerGet(`/forward/cte/${uuid}`);
    return api.data;
  } catch (error) {
    // Mesmo bug do ApiGetDANFECte (ver hotfix "tela de Detalhes do CTe
    // quebrando"): so' logava e nao relancava, entao o thunk via isso como
    // "sucesso" com payload undefined em vez de rejeitado - singleCte virava
    // undefined e a tela ficava com "Nota undefined" sem nenhum aviso quando
    // o servico Forward falha (ex: instabilidade do Elastic Beanstalk).
    // Relancar garante que getSingleCte.rejected rode e o usuario veja o erro.
    handleErrors(error);
  }
};

//--------------------NFCom (modelo 62)--------------------
export const ApiGetNotasNfcom = async (notasNfcom) => {
  let filters = Object.keys(notasNfcom)
    .filter((pos) => notasNfcom[pos] != '')
    .reduce((a, pos) => ({ ...a, [pos]: notasNfcom[pos] }), {});
  // A tela pagina a partir de 0 (TablePagination) e o ELEMENTAR-Back-end a partir de 1
  filters = {
    ...filters,
    page: (Number(notasNfcom.page) || 0) + 1,
    size: notasNfcom.size || 20
  };
  let query = Object.entries(filters)
    .map(([field, value]) => `&${field}=${encodeURIComponent(value)}`)
    .join('');
  let user = await Auth.currentSession();
  try {
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/nfcom-entrada?${query}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetSingleNfcom = async (uuid) => {
  // simpleGet ja chama handleErrors, que relanca: o thunk cai no rejected
  const api = await http.simpleGet(
    `${NOTA_AVULSA_BASE_URL}/api/v1/nfcom/${uuid}`
  );
  return api.data;
};

export const ApiGetXmlNfcom = async (uuid) => {
  const api = await http.simpleGet(
    `${NOTA_AVULSA_BASE_URL}/api/v1/nfcom/xml/${uuid}`
  );
  return api.data;
};

export const ApiPostNotaCte = async ({ arquivoXml, idEmpresa, tipoNota }) => {
  let url = `${FORWARD_BASE_URL}/forward/cte/uploadCte`;
  let data = {
    arquivoXml: arquivoXml,
    idEmpresa: idEmpresa,
    tipoNota: tipoNota
  };
  try {
    const api = await http.secretsManagerPost(url, data);
    return api.data;
  } catch (error) {
    console.log(error);
  }
};

export const ApiPostDownloadMultipleInvoicesCte = async ({
  dataInicio,
  dataFim,
  cnpjEmpresa,
  tipo,
  idUsuario,
  tipoNota
}) => {
  const fields = {
    dataInicio: dataInicio,
    dataFim: dataFim,
    cnpjEmpresa: cnpjEmpresa,
    tipo: tipo,
    idUsuario: idUsuario,
    tipoNota: tipoNota
  };
  const queryArray = Object.entries(fields)
    .filter(
      ([key, value]) =>
        key && value !== undefined && value !== null && value !== ''
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    );
  const queryString = queryArray.length ? `?${queryArray.join('&')}` : '';
  const url = `${NOTA_AVULSA_BASE_URL}/api/v1/cte/downloadDocumentos${queryString}`;
  try {
    const response = await http.simpleGet(url);
    return response.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostManifestacaoCte = async ({ uuid, motivo }) => {
  let data = {
    motivo: motivo
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${NOTA_AVULSA_BASE_URL}/api/v1/cte/manifestacaoDesacordo/${uuid}`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//SERVICO
export const ApiPostNfseFiles = async ({
  arquivoXml,
  codMunicipio,
  idEmpresa,
  tipoNota
}) => {
  let url = `${NOTA_AVULSA_BASE_URL}/api/v1/notas-servico/uploadNota`;
  let data = {
    arquivoXml: arquivoXml,
    codMunicipio: codMunicipio,
    idEmpresa: idEmpresa,
    tipoNota: tipoNota
  };
  try {
    const api = await http.simplePost(url, data);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

/*export const ApiPostNfseNacional = async ({
  arquivoXml,
  idEmpresa,
  tipoNota
}) => {
  let url = `${NOTA_AVULSA_BASE_URL}/api/v1/notas-servico/uploadNotaNacional`;
  let data = {
    arquivoXml: arquivoXml,
    idEmpresa: idEmpresa,
    tipoNota: tipoNota
  };
  try {
    const api = await http.simplePost(url, data);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};*/

export const ApiPostNfseNacional = async ({ base64 }) => {
  let data = {
    base64: base64
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/upload/nfse-nacional`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

export const ApiGetNotasServico = async (notasServico) => {
  let filters = Object.keys(notasServico)
    .filter((pos) => notasServico[pos] != '')
    .reduce((a, pos) => ({ ...a, [pos]: notasServico[pos] }), {});
  if (notasServico.page === 0) {
    filters = {
      ...filters,
      page: 0
    };
  }
  if (notasServico.size === 0 || !notasServico.size) {
    filters = {
      ...filters,
      size: 20
    };
  }
  let filtersArray = Object.entries(filters);
  let queryArray = [];
  for (let i = 0; filtersArray.length > i; i++) {
    let field = filtersArray[i][0];
    let value = filtersArray[i][1];
    let queryString = `&${field}=${value}`;
    queryArray.push(queryString);
  }
  let query = queryArray.join('');
  try {
    const api = await http.simpleGet(
      `${SAFE_NFSE_BASE_URL}/api/v1/notas-servico?${query}`
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetSingleNotaServico = async (uuid) => {
  try {
    const api = await http.simpleGet(
      `${SAFE_NFSE_BASE_URL}/api/v1/notas-servico/${uuid}`
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDANFEServ = async (uuid) => {
  try {
    const api = await http.secretsManagerGet(
      `/forward/notas-servico/impressao/${uuid}`
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetSingleNfse = async (uuid) => {
  try {
    const api = await http.simpleGet(
      `${NOTA_AVULSA_BASE_URL}/api/v1/notas-servico/${uuid}`
    );
    return api.data;
  } catch (error) {
    console.log(error);
  }
};

export const ApiGetServiceErrors = async ({ id, page, per_page }) => {
  let validPage;
  if (page === 0 || page === '0') {
    validPage = 1;
  } else {
    validPage = page;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${MTP_BASE_URL}/erronota/list/servico?id_nota_servico=${id}&page=${validPage}&per_page=${per_page}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostDownloadMultipleInvoicesNfse = async ({
  dataInicio,
  dataFim,
  cnpjEmpresa,
  tipo,
  idUsuario,
  tipoNota
}) => {
  const fields = {
    dataInicio: dataInicio,
    dataFim: dataFim,
    cnpjEmpresa: cnpjEmpresa,
    tipo: tipo,
    idUsuario: idUsuario,
    tipoNota: tipoNota
  };
  const queryArray = Object.entries(fields)
    .filter(
      ([key, value]) =>
        key && value !== undefined && value !== null && value !== ''
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    );
  const queryString = queryArray.length ? `?${queryArray.join('&')}` : '';
  const url = `${NOTA_AVULSA_BASE_URL}/api/v1/notas-servico/downloadDocumentos${queryString}`;
  try {
    const response = await http.simpleGet(url);
    return response.data;
  } catch (error) {
    handleErrors(error);
  }
};

// >>>>>--->>>>>--->>>>>

export const ApiGetNfeWideData = async ({ item_id, invoice_id }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/bold/get-nfe-data?item_id=${item_id}&invoice_id=${invoice_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

export const ApiUpdateNfeWideData = async (nfeFields) => {
  let data = nfeFields;
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_BASE_URL}/bold/update-nfe-data`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
  }
};

// EXPORT MESSAGES MAKE FORWARD

export const ApiGetExportMessages = async ({
  data_inicio,
  data_fim,
  tipo_nota,
  cnpj,
  id_usuario
}) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/messages/export?data_inicio=${data_inicio}&data_fim=${data_fim}&tipo_nota=${tipo_nota}&cnpj=${cnpj}&id_usuario=${id_usuario}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

// EXPORT MESSAGES MAKE FORWARD

export const ApiGetDeclaracoes = async (id_empresa) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${MTP_BASE_URL}/declaration/control_send?id_empresa=${id_empresa}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

export const ApiCreateActionDeclaracao = async ({
  id_action,
  id_declaration_action,
  id_user,
  declaration,
  inclusion_date,
  closing_date,
  email
}) => {
  let data = {
    id_action: id_action,
    id_declaration_action: id_declaration_action,
    id_user: !id_user ? null : null,
    declaration: declaration,
    inclusion_date: inclusion_date,
    closing_date: !closing_date ? null : null,
    email: email
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${MTP_BASE_URL}/declaration/create/company_action`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

export const ApiValidateActionDeclaracao = async ({
  company_action_id,
  closing_date
}) => {
  let data = {
    company_action_id: company_action_id,
    closing_date: closing_date
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${MTP_BASE_URL}/declaration/validate/company_action`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
    throw error;
  }
};

// PEDIDOS BY ID DADOS NOTA

export const ApiGetPedidosByIdDadosNota = async (id_dados_nota) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/pedido/list/by_dados_nota?id_dados_nota=${id_dados_nota}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

// RELATORIO CONSOLIDADO

export const ApiGetConsolidatedReport = async ({
  client_id,
  start_date,
  end_date,
  cnpj_list
}) => {
  try {
    let user = await Auth.currentSession();
    let queryParams = new URLSearchParams({ start_date, end_date });
    if (client_id) {
      queryParams.append('client_id', client_id);
    }
    if (cnpj_list?.length) {
      queryParams.append('cnpj_list', cnpj_list.join(','));
    }
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/relatorio/consolidado?${queryParams.toString()}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

// REFORMA

export const ApiGetCalculoReforma = async ({
  id_dados_nota,
  ano,
  page,
  per_page
}) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/nota_avulsa/list/calculo_xml?id_dados_nota=${id_dados_nota}&ano=${ano}&page=${page}&per_page=${per_page}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleMessages(error);
  }
};

export const ApiProcCalcReforma = async ({ id_dados_nota }) => {
  let data = {
    param: String(id_dados_nota)
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `https://1pixn43uy6.execute-api.us-east-1.amazonaws.com/procedures/call/reforma.nfecalculoreforma`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};
